var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      ref: "form",
      staticClass: "form reportContent formGrid padding-top-20",
      attrs: {
        id: "formReportContent",
        name: "reportContentForm",
        method: "POST",
      },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.recaptchaFormSubmit($event.target)
        },
      },
    },
    [
      _c("div", { staticClass: "formRequiredText" }, [
        _vm._v("\n        " + _vm._s(_vm.trans("REQUIRED")) + "\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "reportContent__formGrid" }, [
        _c("div", { staticClass: "reportContent__right" }, [
          _c(
            "h4",
            {
              staticClass: "sectionSubline",
              attrs: { id: "reportContent--problems" },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.trans("REPORT_CONTENT_PROBLEM_HEADLINE"))
              ),
              _c("sup", [_vm._v("*")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "form__row form__row--radio form__row--inputGroupList",
            },
            [
              _c(
                "div",
                {
                  staticClass: "form__rowItem form__rowItem--inputGroup",
                  attrs: {
                    role: "group",
                    "aria-labelledby": "reportContent--problems",
                  },
                },
                _vm._l(
                  _vm.form.report_content_problems.choices,
                  function (choice, index) {
                    return _c("FormCheckbox", {
                      key: index,
                      attrs: {
                        id: `${_vm.form.report_content_problems.id}_${choice.value}`,
                        field: _vm.form.report_content_problems,
                        value: choice.value,
                        label: choice.label,
                        name: choice.name,
                        required: false,
                        "data-gtm": `formReportContent--${choice.value}`,
                        checked:
                          _vm.form.report_content_problems.value.includes(
                            choice.value
                          ),
                      },
                    })
                  }
                ),
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "h4",
            {
              staticClass: "sectionSubline",
              attrs: { id: "reportContent--damaged" },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.trans("REPORT_CONTENT_DAMAGED_HEADLINE"))
              ),
              _c("sup", [_vm._v("*")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "form__row form__row--radio form__row--inputGroupList",
            },
            [
              _c(
                "div",
                {
                  staticClass: "form__rowItem form__rowItem--inputGroup",
                  attrs: {
                    role: "group",
                    "aria-labelledby": "reportContent--damaged",
                  },
                },
                _vm._l(
                  _vm.form.report_content_damaged.choices,
                  function (choice, index) {
                    return _c("FormRadio", {
                      key: index,
                      attrs: {
                        id: `${_vm.form.report_content_damaged.id}_${choice.value}`,
                        field: _vm.form.report_content_damaged,
                        value: choice.value,
                        label: choice.label,
                        "data-gtm": `formReportContent--${choice.value}`,
                        checked:
                          _vm.form.report_content_damaged.value ===
                          choice.value,
                      },
                    })
                  }
                ),
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "h4",
            {
              staticClass: "sectionSubline",
              attrs: { id: "reportContent--who" },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.trans("REPORT_CONTENT_WHO_HEADLINE"))
              ),
              _c("sup", [_vm._v("*")]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form__row form__row--inputGroupList" }, [
            _c(
              "div",
              {
                staticClass: "form__rowItem form__rowItem--inputGroup",
                attrs: {
                  role: "group",
                  "aria-labelledby": "reportContent--who",
                },
              },
              [
                _c("FormCheckbox", {
                  attrs: { field: _vm.form.report_content_owner },
                }),
                _vm._v(" "),
                _c("FormCheckbox", {
                  attrs: { field: _vm.form.report_content_conscience },
                }),
                _vm._v(" "),
                _c("FormCheckbox", {
                  attrs: { field: _vm.form.report_content_confirm_correctness },
                }),
                _vm._v(" "),
                _c("FormCheckbox", {
                  attrs: { field: _vm.form.report_content_false_accusation },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "reportContent__left" }, [
          _c("h4", { staticClass: "sectionSubline" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.trans("REPORT_CONTENT_DAMAGED_HEADLINE"))
            ),
            _c("sup", [_vm._v("*")]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__row" }, [
            _c(
              "div",
              { staticClass: "form__rowItem" },
              [
                _c("FormInput", {
                  attrs: { field: _vm.form.report_content_firstName },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form__rowItem" },
              [
                _c("FormInput", {
                  attrs: { field: _vm.form.report_content_lastName },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__row" }, [
            _c(
              "div",
              { staticClass: "form__rowItem form__rowItem--mail" },
              [
                _c("FormInput", {
                  attrs: { field: _vm.form.report_content_email },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__row" }, [
            _c(
              "div",
              { staticClass: "form__rowItem form__rowItem--company" },
              [
                _c("FormInput", {
                  attrs: { field: _vm.form.report_content_company },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__row" }, [
            _c(
              "div",
              { staticClass: "form__rowItem form__rowItem--street" },
              [
                _c("FormInput", {
                  attrs: {
                    field: _vm.form.report_content_street,
                    label: _vm.trans("FORM_REGISTER_STREET_NO"),
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__row" }, [
            _c(
              "div",
              { staticClass: "form__rowItem form__rowItem--zipCode" },
              [
                _c("FormInput", {
                  attrs: { field: _vm.form.report_content_zipCode },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form__rowItem form__rowItem--city" },
              [
                _c("FormInput", {
                  attrs: { field: _vm.form.report_content_city },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__row" }, [
            _c(
              "div",
              { staticClass: "form__rowItem form__rowItem--country" },
              [
                _c("FormInput", {
                  attrs: { field: _vm.form.report_content_country },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__row" }, [
            _c(
              "div",
              { staticClass: "form__rowItem" },
              [
                _c("FormInput", {
                  attrs: { field: _vm.form.report_content_signature },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "reportContent__footer" }, [
        _c("div", { staticClass: "form__row form__row--submit" }, [
          _c(
            "div",
            { staticClass: "form__rowItem form__rowItem--submitCenter" },
            [
              _c("FormButton", {
                attrs: {
                  id: "reportContent__submit",
                  type: "submit",
                  classes: "button button--primary button--medium",
                  label: _vm.trans("BUTTON_REPORT_CONTENT"),
                },
                on: { click: _vm.onButtonSubmit },
              }),
              _vm._v(" "),
              _c("FormInput", {
                attrs: {
                  type: "hidden",
                  field: _vm.form.report_content_referer,
                },
              }),
              _vm._v(" "),
              _c("FormInput", {
                attrs: {
                  type: "hidden",
                  field: _vm.form.report_content__token,
                },
              }),
              _vm._v(" "),
              _vm.fieldRecaptcha
                ? _c("FormRecaptcha", {
                    attrs: { triggered: _vm.triggered, sitekey: _vm.sitekey },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }